"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _helpers = require("./helpers");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Ruleset = /*#__PURE__*/function () {
  function Ruleset(preCompiledRuleset) {
    _classCallCheck(this, Ruleset);
    this.preCompiledRuleset = preCompiledRuleset;
  }
  _createClass(Ruleset, [{
    key: "compile",
    value: function compile() {
      var complexRules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var resolved = Ruleset.resolveComplexRules(this.preCompiledRuleset, complexRules);
      return Ruleset.compile(resolved);
    }
  }], [{
    key: "resolveComplexRules",
    value: function resolveComplexRules(preCompiledRuleset) {
      var complexRules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var resultResolvedRuleset = _toConsumableArray(preCompiledRuleset);
      for (var i = 0; i < resultResolvedRuleset.length; ++i) {
        var ruleset = resultResolvedRuleset[i];
        if (ruleset.selector) {
          resultResolvedRuleset[i] = {
            selector: ruleset.selector,
            ruleset: this.resolveComplexRules(ruleset.ruleset, complexRules)
          };
          continue;
        }
        var resolvedRuleset = [ruleset];
        var rules = Object.entries(ruleset);
        for (var j = 0; j < rules.length; ++j) {
          var ruleTitle = rules[j][0];
          var ruleValue = rules[j][1];
          if (!complexRules[ruleTitle]) {
            continue;
          } else {
            delete resolvedRuleset[0][ruleTitle];
            resolvedRuleset = [].concat(_toConsumableArray(resolvedRuleset), _toConsumableArray(complexRules[ruleTitle](ruleValue)));
          }
        }
        resultResolvedRuleset.splice.apply(resultResolvedRuleset, [i, 1].concat(_toConsumableArray(resolvedRuleset)));
      }
      return resultResolvedRuleset;
    }
  }, {
    key: "compile",
    value: function compile(preCompiledRuleset) {
      var _preCompiledRuleset = _toConsumableArray(preCompiledRuleset);
      var css = "";
      for (var i = 0; i < _preCompiledRuleset.length; ++i) {
        var ruleset = _preCompiledRuleset[i];
        if (ruleset.selector) {
          var compiled = Ruleset.compile(ruleset.ruleset);
          css += (0, _helpers.makeCssSelectorAndFillWithRuleset)(ruleset.selector, compiled);
        } else {
          css += (0, _helpers.makeCssRuleset)(ruleset);
        }
      }
      return css;
    }
  }]);
  return Ruleset;
}();
var _default = Ruleset;
exports["default"] = _default;